/** 
  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

// @mui material components
import Icon from "@mui/material/Icon";

// @mui icons
// import GitHubIcon from "@mui/icons-material/GitHub";

// Pages
// Health
import SeniorsHealthPlans from "layouts/pages/health/seniors_health_plans";
import IndividualHealthPlans from "layouts/pages/health/individual_health_plans";
import FamilyHealthPlans from "layouts/pages/health/family_health_plans";
import JuniorHealthPlans from "layouts/pages/health/junior_health_plans";

// Motor
import Comprehensive from "layouts/pages/motor/comprehensive";
import ThirdPartyOnly from "layouts/pages/motor/third_party_only";
import MotorCycleInsurance from "layouts/pages/motor/motor_cycle_insurance";
import PsvBodaBoda from "layouts/pages/motor/psv_boda_boda";
import MotorPsv from "layouts/pages/motor/motor_psv";

// Life
import LifeInsurance from "layouts/pages/life/life_insurance";
import EducationInsurance from "layouts/pages/life/education_insurance";

// Other
import HomeInsurance from "layouts/pages/other/home_insurance";
import PersonalAccidentInsurance from "layouts/pages/other/personal_accident_insurance";
import ProfessionalIndemnityInsurance from "layouts/pages/other/professional_indemnity_insurance";
import FireAndBurglary from "layouts/pages/other/fire_and_burglary";
import LastExpense from "layouts/pages/other/last_expense";
import InsurancePremiumFinancing from "layouts/pages/other/insurance_premium_financing";

// Details
import Details from "layouts/pages/details";
import Profile from "layouts/pages/profile";
import Order from "layouts/pages/order";
import Claim from "layouts/pages/claim";
import Dashboard from "layouts/pages/dashboard";
import Checkout from "layouts/pages/checkout";

import AboutUs from "layouts/pages/landing-pages/about-us";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import Author from "layouts/pages/landing-pages/author";
import SignIn from "layouts/pages/authentication/sign-in";

// Auth
import Login from "auth/login";
import Register from "auth/register";
import ForgotPassword from "auth/forgot-password";
import ResetPassword from "auth/reset-password";

// // Sections
// import PageHeaders from "layouts/sections/page-sections/page-headers";
// import Features from "layouts/sections/page-sections/featuers";
// import Navbars from "layouts/sections/navigation/navbars";
// import NavTabs from "layouts/sections/navigation/nav-tabs";
// import Pagination from "layouts/sections/navigation/pagination";
// import Inputs from "layouts/sections/input-areas/inputs";
// import Forms from "layouts/sections/input-areas/forms";
// import Alerts from "layouts/sections/attention-catchers/alerts";
// import Modals from "layouts/sections/attention-catchers/modals";
// import TooltipsPopovers from "layouts/sections/attention-catchers/tooltips-popovers";
// import Avatars from "layouts/sections/elements/avatars";
// import Badges from "layouts/sections/elements/badges";
// import BreadcrumbsEl from "layouts/sections/elements/breadcrumbs";
// import Buttons from "layouts/sections/elements/buttons";
// import Dropdowns from "layouts/sections/elements/dropdowns";
// import ProgressBars from "layouts/sections/elements/progress-bars";
// import Toggles from "layouts/sections/elements/toggles";
// import Typography from "layouts/sections/elements/typography";

const routes = [
  {
    name: "Health",
    icon: <Icon>health_and_safety</Icon>,
    collapse: [
      {
        name: "Seniors Health Plans",
        description: "All about Seniors Health Plans",
        route: "/health/seniors_health_plans",
        component: <SeniorsHealthPlans />,
      },
      {
        name: "Individual Health Plans",
        description: "All about Individual Health Plans",
        route: "/health/individual_health_plans",
        component: <IndividualHealthPlans />,
      },
      {
        name: "Family Health Plans",
        description: "All about Family Health Plans",
        route: "/health/family_health_plans",
        component: <FamilyHealthPlans />,
      },
      {
        name: "Junior Health Plans",
        description: "All about Junior Health Plans",
        route: "/health/junior_health_plans",
        component: <JuniorHealthPlans />,
      },
    ],
  },
  {
    name: "Motor",
    icon: <Icon>car_repair</Icon>,
    collapse: [
      {
        name: "Comprehensive",
        description: "All about Comprehensive",
        route: "/motor/comprehensive",
        component: <Comprehensive />,
      },
      {
        name: "Third Party Only",
        description: "All about Third Party Only",
        route: "/motor/third_party_only",
        component: <ThirdPartyOnly />,
      },
      {
        name: "Motor Cycle Insurance",
        description: "All about Motor Cycle Insurance",
        route: "/motor/motor_cycle_insurance",
        component: <MotorCycleInsurance />,
      },
      {
        name: "PSV Boda Boda",
        description: "All about PSV Boda Boda",
        route: "/motor/psv_boda_boda",
        component: <PsvBodaBoda />,
      },
      {
        name: "Motor PSV",
        description: "All about Motor PSV",
        route: "/motor/motor_psv",
        component: <MotorPsv />,
      },
    ],
  },
  {
    name: "Life",
    icon: <Icon>diversity_1</Icon>,
    collapse: [
      {
        name: "Life Insurance",
        description: "All about Life Insurance",
        route: "/life/life_insurance",
        component: <LifeInsurance />,
      },
      {
        name: "Education Insurance",
        description: "All about Education Insurance",
        route: "/life/education_insurance",
        component: <EducationInsurance />,
      },
    ],
  },
  {
    name: "Other",
    icon: <Icon>work_history</Icon>,
    collapse: [
      {
        name: "Home Insurance",
        description: "All about Home Insurance",
        route: "/other/home_insurance",
        component: <HomeInsurance />,
      },
      {
        name: "Personal Accident Insurance",
        description: "All about Personal Accident Insurance",
        route: "/other/personal_accident_insurance",
        component: <PersonalAccidentInsurance />,
      },
      {
        name: "Professional Indemnity Insurance",
        description: "All about Professional Indemnity Insurance",
        route: "/other/professional_indemnity_insurance",
        component: <ProfessionalIndemnityInsurance />,
      },
      {
        name: "Fire And Burglary",
        description: "All about Fire And Burglary",
        route: "/other/fire_and_burglary",
        component: <FireAndBurglary />,
      },
      {
        name: "Last Expense",
        description: "All about Last Expense",
        route: "/other/last_expense",
        component: <LastExpense />,
      },
      {
        name: "Insurance Premium Financing",
        description: "All about Insurance Premium Financing",
        route: "/other/insurance_premium_financing",
        component: <InsurancePremiumFinancing />,
      },
    ],
  },
  // {
  //   name: "About Us",
  //   icon: <Icon>folder_shared</Icon>,
  //   collapse: [
  //     {
  //       name: "Overview",
  //       description: "All about Overview",
  //       route: "/pages/landing-pages/about-us",
  //       component: <AboutUs />,
  //     },
  //     {
  //       name: "Our Partners(Author)",
  //       description: "All about Our Partners",
  //       route: "/pages/landing-pages/author",
  //       component: <Author />,
  // },
  //     {
  //       name: "Customer Reviews",
  //       description: "All about Customer Reviews",
  //       route: "/pages/landing-pages/author2",
  //       component: <Author />,
  //     },
  //     {
  //       name: "Press",
  //       description: "All about Press",
  //       route: "/pages/landing-pages/contact-us",
  //       component: <ContactUs />,
  //     },
  //     {
  //       name: "Careers",
  //       description: "All about Careers",
  //       route: "/pages/landing-pages/contact-us2",
  //       component: <ContactUs />,
  //     },
  //   ],
  // },
  // {
  //   name: "Tools",
  //   icon: <Icon>construction</Icon>,
  //   collapse: [
  //     {
  //       name: "Income Tax Calculator",
  //       description: "All about Income Tax Calculator",
  //       route: "/pages/landing-pages/contact-us",
  //       component: <ContactUs />,
  //     },
  //     {
  //       name: "Loan Calculator",
  //       description: "All about Loan Calculator",
  //       route: "/pages/landing-pages/contact-us",
  //       component: <ContactUs />,
  //     },
  //     {
  //       name: "Currency Converter",
  //       description: "All about Currency Converter",
  //       route: "/pages/landing-pages/contact-us",
  //       component: <ContactUs />,
  //     },
  //     {
  //       name: "Body Mass Index (BMI)",
  //       description: "All about Body Mass Index (BMI)",
  //       route: "/pages/landing-pages/contact-us",
  //       component: <ContactUs />,
  //     },
  //   ],
  // },
  // {
  // name: "Support",
  // icon: <Icon>support_agent</Icon>,
  // collapse: [
  //   {
  //     name: "Claim",
  //     description: "All about Claim",
  //     route: "/pages/landing-pages/contact-us",
  //     component: <ContactUs />,
  //   },
  //   {
  //     name: "FAQs",
  //     description: "All about FAQs",
  //     route: "/pages/landing-pages/contact-us",
  //     component: <ContactUs />,
  //   },
  //   {
  //     name: "Contact Us",
  //     description: "All about Contact Us",
  //     route: "/pages/landing-pages/contact-us",
  //     component: <ContactUs />,
  //   },
  // ],
  // },
];

const routesToExcludeFromNavbar = [
  {
    name: "Plan Details",
    description: "All about Plan Details",
    route: "/details/:id",
    component: <Details />,
  },
  {
    name: "Profile",
    description: "All about Profile",
    route: "/profile",
    component: <Profile />,
  },
  {
    name: "Dashboard",
    description: "Your Dashboard",
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    name: "Plan Order",
    description: "All about Plan Order",
    route: "/order/:id",
    component: <Order />,
  },
  {
    name: "Checkout",
    description: "All about CHeckout",
    route: "/checkout/:id",
    component: <Checkout />,
  },
  {
    name: "Make Claim",
    description: "All about Make Claim",
    route: "/claim/:id",
    component: <Claim />,
  },
  {
    type: "auth",
    name: "Login",
    key: "login",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/auth/login",
    component: <Login />,
  },
  {
    type: "auth",
    name: "Register",
    key: "register",
    icon: <Icon fontSize="small">register</Icon>,
    route: "/auth/register",
    component: <Register />,
  },
  {
    type: "auth",
    name: "Forgot Password",
    key: "forgot-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/auth/forgot-password",
    component: <ForgotPassword />,
  },
  {
    type: "auth",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/auth/reset-password",
    component: <ResetPassword />,
  },
];

export { routes, routesToExcludeFromNavbar };
